module.exports = __webpack_public_path__ + "img/dailyInspection_uncheck.441a7ebe.png";